import { apiClient } from "@/lib/api-client";

export type UnsurMengujiProposalData = Record<string, any>;

export type UnsurMengujiProposalResponse = {
  datas: UnsurMengujiProposalData;
  message: string;
};

export const fetchUnsurMengujiProposal = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurMengujiProposalData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurMengujiProposalResponse>(
    `${baseUrl}/api/v1/unsur-menguji-proposal/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
